import styled from 'styled-components'

export const List = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const ListItem = styled.li`
  width: 100%;
  padding: 15px 15px 15px 0;
  :not(:last-child) {
    border-bottom: 1px solid ${props => props.theme.colors.nori};
  }
`;

export const Note = styled.div`
  font-family: ${props => props.theme.fonts.poppins};
  color: ${props => props.theme.colors.nori};
  font-weight: 500;
  font-size: 1.7rem;
  line-height: 2.4rem;
`;